import { render, staticRenderFns } from "./AnnounceMark.vue?vue&type=template&id=80e62490&scoped=true&"
import script from "./AnnounceMark.vue?vue&type=script&lang=js&"
export * from "./AnnounceMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e62490",
  null
  
)

export default component.exports